import moment from 'moment-timezone';
import { isAllTimeFilter } from '../../workoutAggregateFilter';

export function formatNumber(value: number): string {
  return Math.round(value).toLocaleString('en-US');
}

export function formatStatsDateRange(
  dateRange?: { startDate?: Date, endDate?: Date },
  timezone?: string,
): string {
  if (!dateRange?.startDate || !dateRange?.endDate) {
    return 'Select a Stats date range';
  }

  if (isAllTimeFilter(dateRange as any)) {
    return 'All time';
  }

  const start = toReportMoment(dateRange.startDate, timezone);
  const end = toReportMoment(dateRange.endDate, timezone);

  if (start.isSame(end, 'day')) {
    return start.format('D MMMM YYYY');
  }
  if (start.isSame(end, 'month')) {
    return `${start.format('D')} - ${end.format('D MMMM YYYY')}`;
  }
  if (start.isSame(end, 'year')) {
    return `${start.format('D MMM')} - ${end.format('D MMMM YYYY')}`;
  }
  return `${start.format('D MMM YYYY')} - ${end.format('D MMM YYYY')}`;
}

export function formatCompactNumber(value: number): string {
  if (Math.abs(value) >= 1000000) {
    return `${formatTrimmed(value / 1000000)}M`;
  }
  if (Math.abs(value) >= 1000) {
    return `${formatTrimmed(value / 1000)}K`;
  }
  return formatNumber(value);
}

function formatTrimmed(value: number): string {
  return value.toFixed(value >= 10 ? 0 : 1).replace(/\.0$/, '');
}

function toReportMoment(date: Date, timezone?: string): moment.Moment {
  return timezone ? moment(date).tz(timezone) : moment(date);
}
